// import React from 'react'
// import { Link } from "react-router-dom";


// const HomeBanner = (props) => {
//    const  homeBannerData = props.data || []
//     console.log("homeBannerData----",homeBannerData)

//     return (
//         <>
//             <div className='wrapper' id="wrapper">

//                 <section className="bg-accent border-bottom add-top-margin" style={{ marginTop: "1px" }}>
//                     <div className="">
//                         <div className="row no-gutters d-flex align-items-center" style={{}}>
//                             <div className="col-lg-2 col-md-3 col-sm-4 col-6">
//                                 <div className="topic-box topic-box-margin">शीर्ष समाचार</div>
//                             </div>
//                             <div className="col-lg-10 col-md-9 col-sm-8 col-6">
//                                 <div className="feeding-text-dark">
//                                     <p id="sample" className="ticker">
//                                         <li style={{color:"black"}}>
//                                             <marquee width="" direction="left" height="">
//                                                 1. यदि आप अपनी कोई खबर, सार्वजनिक सूचना, गुमशुदा, नाम परिवर्तन सूचना, बिजनेस आइडिया, रिसर्च रिपोर्ट, विज्ञापन, जन्मदिवस, पुण्यतिथि, सालगिरह की बधाईयाॅ प्रकाशित कराना चाहते है तो आप हमसे 7987667358 पर संपर्क या व्हाट्सअप कर सकते है। अथवा डिटेल्स के साथ डाक्यूमेन्ट्स अटेच कर starnewsnetworks1988@gmail.com पर ईमेल करें। धन्यवाद
//                                                 2. अगर आप हमसे जुड़ना चाहते है या कोई विज्ञापन देना चाहते है या हमें कोई सुझाव देना चाहते है तो हमसे मो0न0 7987667358 पर संपर्क या व्हाट्सअप करें|
//                                             </marquee>

//                                         </li>
//                                         {/* <li>
//                                             <Link to="#">Magnificent Image Of The New Hoover Dam Bridge Taking Shape</Link>
//                                         </li>
//                                         <li>
//                                             <Link to="#">If Obama Had Governed Like This in 2017 He'd Be the
//                                                 Transformational.</Link>
//                                         </li> */}
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>

//                 <section className="bg-body">
//                     <div className="container">
//                         <ul className="news-info-list text-center--md">
//                             <li>
//                                 <i className="fa fa-map-marker" aria-hidden="true" />India
//                             </li>
//                             <li>
//                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" /><span id="current_date" />
//                             </li>
//                             <li>
//                                 <i className="fa fa-clock-o" aria-hidden="true" />Last Update 11.30 am
//                             </li>
//                             <li>
//                                 <i className="fa fa-cloud" aria-hidden="true" />29℃ Friday, India
//                             </li>
//                         </ul>
//                     </div>
//                 </section>
//                 <section className="bg-accent section-space-less2">
//                     <div className="container">
//                         <div className="row tab-space1">
//                             <div className="col-lg-6 col-md-12">
//                                 <div className="img-overlay-70 img-scale-animate mb-2">
//                                     <img src="/assets/img/news/news1.jpg" alt="news" className="img-fluid width-100" />
//                                     <div className="mask-content-lg">
//                                         <div className="topic-box-sm color-cinnabar mb-20">पन्ना की ताज़ा खबरें</div>
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>by</span>
//                                                     <Link to="/news-info">Admin</Link>
//                                                 </li>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2025
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h1 className="title-medium-light">
//                                             <Link to="/news-info">सीएम मोहन बोले- एमपी में चलेंगी 900 ई-बसें</Link>
//                                         </h1>
//                                         <p style={{color:"white"}}>प्रदेश के ग्वालियर, जबलपुर, उज्जैन, भोपाल, इंदौर नगर निगम क्षेत्रों में ई- बसों के लिए चार्जिंग स्टेशन बनाए जाने के…</p>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-md-12">
//                                 <div className="row tab-space1">
//                                     <div className="col-12">
//                                         <div className="img-overlay-70 img-scale-animate mb-2">
//                                             <div className="mask-content-sm">
//                                                 <div className="topic-box-sm color-azure-radiance mb-10">Sports</div>
//                                                 <h2 className="title-medium-light">
//                                                     <Link to="/news-info">कभी चोट के चलते भाला नहीं फेंक पा रहे थे नीरज चोपड़ा, मुंबई में हुई सर्जरी फिर मिला ‘ओलंपिक वाला हाथ’</Link>
//                                                 </h2>
//                                                 <p style={{color:"white"}}>नीरज चोपड़ा ने शनिवार को टोक्यो ओलंपिक में 87.58 मीटर भाला फेंककर भारत को गोल्ड मेडल दिलाया. नीरज 2018 कॉमनवेल्थ…</p>
//                                             </div>
//                                             <img src="/assets/img/news/news2.jpg" alt="news" className="img-fluid width-100" />
//                                         </div>
//                                     </div>
//                                     <div className="col-sm-6 col-12">
//                                         <div className="img-overlay-70 img-scale-animate mb-2">
//                                             <div className="mask-content-sm">
//                                                 <div className="topic-box-sm color-apple mb-10">पन्ना की ताज़ा खबरें</div>
//                                                 <h3 className="title-medium-light">
//                                                     <Link to="/news-info">नगर परिषद अध्यक्ष देवेंद्रनगर के पति ललित ग़ुप्ता पर पिस्तौल से हुआ  </Link>
//                                                 </h3>
//                                                 {/* <p style={{color:"white"}}>पन्ना,  जिले के देवेंद्र नगर थाना मुख्यालय में नगर पंचायत अध्यक्ष शिवांगी गुप्ता के पति ललित गुप्ता उर्फ लाम्पा  पर एक बदमाश द्वारा पिस्तौल से फायरिंग की गई जिसमें ललित गुप्ता की कनपटी एवं हाथ में गोली लगी है</p> */}
//                                             </div>
//                                             <img src="/assets/img/news/news3.jpg" alt="news" className="img-fluid width-100" />
//                                         </div>
//                                     </div>
//                                     <div className="col-sm-6 col-12">
//                                         <div className="img-overlay-70 img-scale-animate mb-2">
//                                             <div className="mask-content-sm">
//                                                 <div className="topic-box-sm color-razzmatazz mb-10">पन्ना की ताज़ा खबरें</div>
//                                                 <h3 className="title-medium-light">
//                                                     <Link to="/news-info">स्कूल बस दुर्घटना में घायल बच्चों का हुआ उपचार, सकुशल वापस</Link>
//                                                 </h3>
//                                             </div>
//                                             <img src="/assets/img/news/news4.jpg" alt="news" className="img-fluid width-100" />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>

//                 {/* <section className="bg-body section-space-default">
//                     <div className="container">
//                         <div className="row">
//                             <div className="col-lg-8 col-md-12">
//                                 <div className="mb-20-r ne-isotope">
//                                     <div className="topic-border color-cinnabar mb-30">
//                                         <div className="topic-box-lg color-cinnabar">Top Stories</div>
//                                         <div className="isotope-classes-tab isotop-btn">
//                                             <Link to="#" data-filter=".politics" className="current">Politics</Link>
//                                             <Link to="#" data-filter=".fashion">Fashion</Link>
//                                             <Link to="#" data-filter=".travel">Travel</Link>
//                                             <Link to="#" data-filter=".gadget">Gadget</Link>
//                                         </div>
//                                         <div className="more-info-link">
//                                             <Link to="post-style-1.html">More
//                                                 <i className="fa fa-angle-right" aria-hidden="true" />
//                                             </Link>
//                                         </div>
//                                     </div>
//                                     <div className="featuredContainer">
//                                         <div className="row politics">
//                                             <div className="col-md-6 col-sm-12">
//                                                 <div className="img-overlay-70 img-scale-animate mb-30">
//                                                     <Link to="/news-info">
//                                                         <img src="/assets/img/news/news5.jpg" alt="news" className="img-fluid width-100" />
//                                                     </Link>
//                                                     <div className="mask-content-lg">
//                                                         <div className="topic-box-sm color-cinnabar mb-20">Politics</div>
//                                                         <div className="post-date-light">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Adams</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>March 22, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h2 className="title-medium-light size-lg">
//                                                             <Link to="/news-info">Government launches are inquiry into
//                                                                 tainted ...</Link>
//                                                         </h2>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6 col-sm-12">
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news6.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>February 10, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news7.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>January 10, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">UAE athlete dies after inden London
//                                                                 training ground.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news8.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>December 15, 2016
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news9.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>November 23, 2016
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row fashion">
//                                             <div className="col-md-6 col-sm-12">
//                                                 <div className="img-overlay-70 img-scale-animate mb-30">
//                                                     <Link to="/news-info">
//                                                         <img src="/assets/img/news/news46.jpg" alt="news" className="img-fluid width-100" />
//                                                     </Link>
//                                                     <div className="mask-content-lg">
//                                                         <div className="topic-box-sm color-azure-radiance mb-20">Fashion</div>
//                                                         <div className="post-date-light">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Adams</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>March 22, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h2 className="title-medium-light size-lg">
//                                                             <Link to="/news-info">Government launches are inquiry into
//                                                                 tainted ...</Link>
//                                                         </h2>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6 col-sm-12">
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news6.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>February 10, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news7.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>January 10, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">UAE athlete dies after inden London
//                                                                 training ground.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news8.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>December 15, 2016
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news9.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>November 23, 2016
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row travel">
//                                             <div className="col-md-6 col-sm-12">
//                                                 <div className="img-overlay-70 img-scale-animate mb-30">
//                                                     <Link to="/news-info">
//                                                         <img src="/assets/img/news/news48.jpg" alt="news" className="img-fluid width-100" />
//                                                     </Link>
//                                                     <div className="mask-content-lg">
//                                                         <div className="topic-box-sm color-web-orange mb-20">Gadget</div>
//                                                         <div className="post-date-light">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Adams</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>March 22, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h2 className="title-medium-light size-lg">
//                                                             <Link to="/news-info">Government launches are inquiry into
//                                                                 tainted ...</Link>
//                                                         </h2>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6 col-sm-12">
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news6.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>February 10, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news7.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>January 10, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">UAE athlete dies after inden London
//                                                                 training ground.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news8.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>December 15, 2016
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news9.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>November 23, 2016
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row gadget">
//                                             <div className="col-md-6 col-sm-12">
//                                                 <div className="img-overlay-70 img-scale-animate mb-30">
//                                                     <Link to="/news-info">
//                                                         <img src="/assets/img/news/news49.jpg" alt="news" className="img-fluid width-100" />
//                                                     </Link>
//                                                     <div className="mask-content-lg">
//                                                         <div className="topic-box-sm color-web-orange mb-20">Gadget</div>
//                                                         <div className="post-date-light">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Adams</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>March 22, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h2 className="title-medium-light size-lg">
//                                                             <Link to="/news-info">Government launches are inquiry into
//                                                                 tainted ...</Link>
//                                                         </h2>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6 col-sm-12">
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news6.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>February 10, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news7.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>January 10, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">UAE athlete dies after inden London
//                                                                 training ground.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news8.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>December 15, 2016
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                                 <div className="media mb-30">
//                                                     <Link className="width38-lg width40-md img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news9.jpg" alt="news" className="img-fluid" />
//                                                     </Link>
//                                                     <div className="media-body">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>November 23, 2016
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-medium-dark size-md mb-none">
//                                                             <Link to="/news-info">Blog post look better they are with a
//                                                                 featured.</Link>
//                                                         </h3>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row tab-space1 mb-25">
//                                     <div className="col-12">
//                                         <div className="topic-border color-apple mb-30 width-100">
//                                             <div className="topic-box-lg color-apple">Life Style</div>
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-4 col-md-6 col-sm-6 col-6">
//                                         <div className="img-overlay-70 img-scale-animate mb-2">
//                                             <div className="mask-content-xs">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>February 10, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h3 className="title-medium-light">
//                                                     <Link to="/news-info">Rosie Huntington Whitel Habits Career Art </Link>
//                                                 </h3>
//                                             </div>
//                                             <img src="/assets/img/news/news10.jpg" alt="news" className="img-fluid width-100" />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-4 col-md-6 col-sm-6 col-6">
//                                         <div className="img-overlay-70 img-scale-animate mb-2">
//                                             <div className="mask-content-xs">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>February 10, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h3 className="title-medium-light">
//                                                     <Link to="/news-info">Smart packs parking beeps sensor </Link>
//                                                 </h3>
//                                             </div>
//                                             <img src="/assets/img/news/news11.jpg" alt="news" className="img-fluid width-100" />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-4 col-md-6 col-sm-6 col-6">
//                                         <div className="img-overlay-70 img-scale-animate mb-2">
//                                             <div className="mask-content-xs">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>February 10, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h3 className="title-medium-light">
//                                                     <Link to="/news-info">Budget issues force the our to be cancelled
//                                                     </Link>
//                                                 </h3>
//                                             </div>
//                                             <img src="/assets/img/news/news12.jpg" alt="news" className="img-fluid width-100" />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-4 col-md-6 col-sm-6 col-6">
//                                         <div className="img-overlay-70 img-scale-animate mb-2">
//                                             <div className="mask-content-xs">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>February 10, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h3 className="title-medium-light">
//                                                     <Link to="/news-info">Here What’s in Battlefield $80 Deluxe Edition
//                                                     </Link>
//                                                 </h3>
//                                             </div>
//                                             <img src="/assets/img/news/news13.jpg" alt="news" className="img-fluid width-100" />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-4 col-md-6 col-sm-6 col-6">
//                                         <div className="img-overlay-70 img-scale-animate mb-2">
//                                             <div className="mask-content-xs">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>February 10, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h3 className="title-medium-light">
//                                                     <Link to="/news-info">Rosie Huntington Whitel Habits Career Art </Link>
//                                                 </h3>
//                                             </div>
//                                             <img src="/assets/img/news/news14.jpg" alt="news" className="img-fluid width-100" />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-4 col-md-6 col-sm-6 col-6">
//                                         <div className="img-overlay-70 img-scale-animate mb-2">
//                                             <div className="mask-content-xs">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>February 10, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h3 className="title-medium-light">
//                                                     <Link to="/news-info">Rosie Huntington Whitel Habits Career Art </Link>
//                                                 </h3>
//                                             </div>
//                                             <img src="/assets/img/news/news15.jpg" alt="news" className="img-fluid width-100" />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="ne-sidebar sidebar-break-md col-lg-4 col-md-12">
//                                 <div className="sidebar-box">
//                                     <div className="topic-border color-cod-gray mb-30">
//                                         <div className="topic-box-lg color-cod-gray">Stay Connected</div>
//                                     </div>
//                                     <ul className="stay-connected overflow-hidden">
//                                         <li className="facebook">
//                                             <i className="fa fa-facebook" aria-hidden="true" />
//                                             <div className="connection-quantity">50k</div>
//                                             <p>Fans</p>
//                                         </li>
//                                         <li className="twitter">
//                                             <i className="fa fa-twitter" aria-hidden="true" />
//                                             <div className="connection-quantity">10k</div>
//                                             <p>Followers</p>
//                                         </li>
//                                         <li className="linkedin">
//                                             <i className="fa fa-linkedin" aria-hidden="true" />
//                                             <div className="connection-quantity">25k</div>
//                                             <p>Fans</p>
//                                         </li>
//                                         <li className="rss">
//                                             <i className="fa fa-rss" aria-hidden="true" />
//                                             <div className="connection-quantity">20k</div>
//                                             <p>Subscriber</p>
//                                         </li>
//                                     </ul>
//                                 </div>
//                                 <div className="sidebar-box">
//                                     <div className="ne-banner-layout1 text-center">
//                                         <Link to="#">
//                                             <img src="/assets/img/banner/banner3.jpg" alt="ad" className="img-fluid" />
//                                         </Link>
//                                     </div>
//                                 </div>
//                                 <div className="sidebar-box">
//                                     <div className="topic-border color-scampi mb-5">
//                                         <div className="topic-box-lg color-scampi">Recent News</div>
//                                     </div>
//                                     <div className="row">
//                                         <div className="col-lg-6 col-md-6 col-sm-6 col-6">
//                                             <div className="mt-25">
//                                                 <Link to="/news-info" className="img-opacity-hover">
//                                                     <img src="/assets/img/news/news42.jpg" alt="ad" className="img-fluid mb-10 width-100" />
//                                                 </Link>
//                                                 <h3 className="title-medium-dark size-md mb-none">
//                                                     <Link to="/news-info">Rosie Huntington Whitl Habits Career Art
//                                                         Rosie.</Link>
//                                                 </h3>
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-6 col-md-6 col-sm-6 col-6">
//                                             <div className="mt-25">
//                                                 <Link to="/news-info" className="img-opacity-hover">
//                                                     <img src="/assets/img/news/news43.jpg" alt="ad" className="img-fluid mb-10 width-100" />
//                                                 </Link>
//                                                 <h3 className="title-medium-dark size-md mb-none">
//                                                     <Link to="/news-info">Brings air of distinction to Delafield
//                                                         tist.</Link>
//                                                 </h3>
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-6 col-md-6 col-sm-6 col-6">
//                                             <div className="mt-25">
//                                                 <Link to="/news-info" className="img-opacity-hover">
//                                                     <img src="/assets/img/news/news44.jpg" alt="ad" className="img-fluid mb-10 width-100" />
//                                                 </Link>
//                                                 <h3 className="title-medium-dark size-md mb-none">
//                                                     <Link to="/news-info">Haunts of the Hea Lans capes of Lynn Zirman
//                                                         Career.</Link>
//                                                 </h3>
//                                             </div>
//                                         </div>
//                                         <div className="col-lg-6 col-md-6 col-sm-6 col-6">
//                                             <div className="mt-25">
//                                                 <Link to="/news-info" className="img-opacity-hover">
//                                                     <img src="/assets/img/news/news45.jpg" alt="ad" className="img-fluid mb-10 width-100" />
//                                                 </Link>
//                                                 <h3 className="title-medium-dark size-md mb-none">
//                                                     <Link to="/news-info">Rosie Huntington Whitl Habits Career Art.Rosie
//                                                         Habits.</Link>
//                                                 </h3>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row">
//                             <div className="col-12">
//                                 <div className="ne-banner-layout1 mt-20-r text-center">
//                                     <Link to="#">
//                                         <img src="/assets/img/banner/banner2.jpg" alt="ad" className="img-fluid" />
//                                     </Link>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>

//                 <section className="bg-accent section-space-less4">
//                     <div className="container">
//                         <div className="row tab-space2">
//                             <div className="col-lg-4 col-md-12 mb-4">
//                                 <div className="img-overlay-70">
//                                     <div className="mask-content-sm">
//                                         <div className="topic-box-sm color-pomegranate mb-20">Fitness</div>
//                                         <h3 className="title-medium-light">
//                                             <Link to="/news-info">Gym Fitness area coverded they Governed this in
//                                                 2017</Link>
//                                         </h3>
//                                     </div>
//                                     <div className="text-center">
//                                         <Link className="play-btn popup-youtube" to="http://www.youtube.com/watch?v=1iIZeIy7TqM">
//                                             <img src="/assets/img/banner/play.png" alt="play" className="img-fluid" />
//                                         </Link>
//                                     </div>
//                                     <img src="/assets/img/news/news16.jpg" alt="news" className="img-fluid width-100" />
//                                 </div>
//                             </div>
//                             <div className="col-lg-4 col-md-12 mb-4">
//                                 <div className="img-overlay-70">
//                                     <div className="mask-content-sm">
//                                         <div className="topic-box-sm color-persian-green mb-20">Business</div>
//                                         <h3 className="title-medium-light">
//                                             <Link to="/news-info">Patricia Urquiola transparent furney Italia with
//                                                 iridescent</Link>
//                                         </h3>
//                                     </div>
//                                     <div className="text-center">
//                                         <Link className="play-btn popup-youtube" to="http://www.youtube.com/watch?v=1iIZeIy7TqM">
//                                             <img src="/assets/img/banner/play.png" alt="play" className="img-fluid" />
//                                         </Link>
//                                     </div>
//                                     <img src="/assets/img/news/news17.jpg" alt="news" className="img-fluid width-100" />
//                                 </div>
//                             </div>
//                             <div className="col-lg-4 col-md-12 mb-4">
//                                 <div className="img-overlay-70">
//                                     <div className="mask-content-sm">
//                                         <div className="topic-box-sm color-web-orange mb-20">Food</div>
//                                         <h3 className="title-medium-light">
//                                             <Link to="/news-info">Denton Corker Marshall the myste biennale pavilion</Link>
//                                         </h3>
//                                     </div>
//                                     <div className="text-center">
//                                         <Link className="play-btn popup-youtube" to="http://www.youtube.com/watch?v=1iIZeIy7TqM">
//                                             <img src="img/banner/play.png" alt="play" className="img-fluid" />
//                                         </Link>
//                                     </div>
//                                     <img src="/assets/img/news/news18.jpg" alt="news" className="img-fluid width-100" />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section> */}

//                 {/* <section className="bg-body section-space-less30">
//                     <div className="container">
//                         <div className="row">
//                             <div className="col-lg-4 col-md-12">
//                                 <div className="topic-border color-cutty-sark mb-30 width-100">
//                                     <div className="topic-box-lg color-cutty-sark">Tech World</div>
//                                 </div>
//                                 <div className="img-overlay-70 img-scale-animate mb-30">
//                                     <div className="mask-content-sm">
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>by</span>
//                                                     <Link to="/news-info">Adams</Link>
//                                                 </li>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>May 30, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-light">
//                                             <Link to="/news-info">Oppo Find 7 is the world need first phone that can
//                                                 take</Link>
//                                         </h3>
//                                     </div>
//                                     <img src="/assets/img/news/news19.jpg" alt="news" className="img-fluid width-100" />
//                                 </div>
//                                 <div className="media mb-30">
//                                     <Link className="img-opacity-hover" to="/news-info">
//                                         <img src="/assets/img/news/news20.jpg" alt="news" className="img-fluid" />
//                                     </Link>
//                                     <div className="media-body">
//                                         <div className="post-date-dark">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-dark size-md mb-none">
//                                             <Link to="/news-info">Dogs Can Be Monito road with Hi Tech Program</Link>
//                                         </h3>
//                                     </div>
//                                 </div>
//                                 <div className="media mb-30">
//                                     <Link className="img-opacity-hover" to="/news-info">
//                                         <img src="/assets/img/news/news21.jpg" alt="news" className="img-fluid" />
//                                     </Link>
//                                     <div className="media-body">
//                                         <div className="post-date-dark">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-dark size-md mb-none">
//                                             <Link to="/news-info">Microsoft Subsumes Open nside Mothership</Link>
//                                         </h3>
//                                     </div>
//                                 </div>
//                                 <div className="media mb-30">
//                                     <Link className="img-opacity-hover" to="/news-info">
//                                         <img src="/assets/img/news/news22.jpg" alt="news" className="img-fluid" />
//                                     </Link>
//                                     <div className="media-body">
//                                         <div className="post-date-dark">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-dark size-md mb-none">
//                                             <Link to="/news-info">Dogs Can Be Monito road with Hi Tech Program.</Link>
//                                         </h3>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-4 col-md-12">
//                                 <div className="topic-border color-pomegranate mb-30 width-100">
//                                     <div className="topic-box-lg color-pomegranate">Health &amp; Fitness</div>
//                                 </div>
//                                 <div className="img-overlay-70 img-scale-animate mb-30">
//                                     <div className="mask-content-sm">
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>by</span>
//                                                     <Link to="/news-info">Adams</Link>
//                                                 </li>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>March 22, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-light">
//                                             <Link to="/news-info">Oppo Find 7 is the world need first phone that can
//                                                 take</Link>
//                                         </h3>
//                                     </div>
//                                     <img src="/assets/img/news/news23.jpg" alt="news" className="img-fluid width-100" />
//                                 </div>
//                                 <div className="media mb-30">
//                                     <Link className="img-opacity-hover" to="/news-info">
//                                         <img src="/assets/img/news/news24.jpg" alt="news" className="img-fluid" />
//                                     </Link>
//                                     <div className="media-body">
//                                         <div className="post-date-dark">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-dark size-md mb-none">
//                                             <Link to="/news-info">Dogs Can Be Monito road with Hi Tech Program</Link>
//                                         </h3>
//                                     </div>
//                                 </div>
//                                 <div className="media mb-30">
//                                     <Link className="img-opacity-hover" to="/news-info">
//                                         <img src="/assets/img/news/news25.jpg" alt="news" className="img-fluid" />
//                                     </Link>
//                                     <div className="media-body">
//                                         <div className="post-date-dark">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-dark size-md mb-none">
//                                             <Link to="/news-info">Microsoft Subsumes Open nside Mothership</Link>
//                                         </h3>
//                                     </div>
//                                 </div>
//                                 <div className="media mb-30">
//                                     <Link className="img-opacity-hover" to="/news-info">
//                                         <img src="/assets/img/news/news26.jpg" alt="news" className="img-fluid" />
//                                     </Link>
//                                     <div className="media-body">
//                                         <div className="post-date-dark">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-dark size-md mb-none">
//                                             <Link to="/news-info">Dogs Can Be Monito road with Hi Tech Program.</Link>
//                                         </h3>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-4 col-md-12">
//                                 <div className="topic-border color-web-orange mb-30 width-100">
//                                     <div className="topic-box-lg color-web-orange">Tech World</div>
//                                 </div>
//                                 <div className="img-overlay-70 img-scale-animate mb-30">
//                                     <div className="mask-content-sm">
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>by</span>
//                                                     <Link to="/news-info">Adams</Link>
//                                                 </li>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>April 16, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-light">
//                                             <Link to="/news-info">SpringFest One Fashion Show at the University of
//                                                 Michigan</Link>
//                                         </h3>
//                                     </div>
//                                     <img src="/assets/img/news/news27.jpg" alt="news" className="img-fluid width-100" />
//                                 </div>
//                                 <div className="media mb-30">
//                                     <Link className="img-opacity-hover" to="/news-info">
//                                         <img src="/assets/img/news/news28.jpg" alt="news" className="img-fluid" />
//                                     </Link>
//                                     <div className="media-body">
//                                         <div className="post-date-dark">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-dark size-md mb-none">
//                                             <Link to="/news-info">Dogs Can Be Monito road with Hi Tech Program</Link>
//                                         </h3>
//                                     </div>
//                                 </div>
//                                 <div className="media mb-30">
//                                     <Link className="img-opacity-hover" to="/news-info">
//                                         <img src="/assets/img/news/news29.jpg" alt="news" className="img-fluid" />
//                                     </Link>
//                                     <div className="media-body">
//                                         <div className="post-date-dark">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-dark size-md mb-none">
//                                             <Link to="/news-info">Microsoft Subsumes Open nside Mothership</Link>
//                                         </h3>
//                                     </div>
//                                 </div>
//                                 <div className="media mb-30">
//                                     <Link className="img-opacity-hover" to="/news-info">
//                                         <img src="/assets/img/news/news30.jpg" alt="news" className="img-fluid" />
//                                     </Link>
//                                     <div className="media-body">
//                                         <div className="post-date-dark">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>February 10, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h3 className="title-medium-dark size-md mb-none">
//                                             <Link to="/news-info">Dogs Can Be Monito road with Hi Tech Program.</Link>
//                                         </h3>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row">
//                             <div className="col-12">
//                                 <div className="ne-banner-layout1 mb-50 mt-20-r text-center">
//                                     <Link to="#">
//                                         <img src="/assets/img/banner/banner2.jpg" alt="ad" className="img-fluid" />
//                                     </Link>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="ne-isotope">
//                             <div className="row">
//                                 <div className="col-12">
//                                     <div className="topic-border color-azure-radiance mb-30">
//                                         <div className="topic-box-lg color-azure-radiance">Sports</div>
//                                         <div className="isotope-classes-tab isotop-btn">
//                                             <Link to="#" data-filter=".tenies" className="current">Tenies</Link>
//                                             <Link to="#" data-filter=".cricket">Cricket</Link>
//                                             <Link to="#" data-filter=".football">Football</Link>
//                                             <Link to="#" data-filter=".cycling">Cycling</Link>
//                                         </div>
//                                         <div className="more-info-link">
//                                             <Link to="post-style-1.html">More
//                                                 <i className="fa fa-angle-right" aria-hidden="true" />
//                                             </Link>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="featuredContainer">
//                                 <div className="row tenies">
//                                     <div className="col-xl-4 col-lg-7 col-md-6 col-sm-12">
//                                         <div className="img-overlay-70 img-scale-animate mb-30">
//                                             <img src="/assets/img/news/news31.jpg" alt="news" className="img-fluid width-100" />
//                                             <div className="topic-box-top-lg">
//                                                 <div className="topic-box-sm color-cod-gray mb-20">Tenis</div>
//                                             </div>
//                                             <div className="mask-content-lg">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>by</span>
//                                                             <Link to="/news-info">Adams</Link>
//                                                         </li>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>May 30, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h2 className="title-medium-light size-lg">
//                                                     <Link to="/news-info">10 Best Water Parks In Theya World you Have
//                                                         to...</Link>
//                                                 </h2>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-xl-8 col-lg-5 col-md-6 col-sm-12">
//                                         <div className="row keep-items-4-md">
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news32.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Ragbe</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>January 17, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Brooke Shields Casts a New Dress Model</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news33.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Boxing</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>February 10, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Brooke Shields Casts a New Dress Model</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news34.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Diving</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>March 06, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Music Evolution, the Most Advanced Audio
//                                                             Mixer</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news35.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Cycling</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>May 17, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Hexagon is the new circle but we need to
//                                                             know in 2017</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news36.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Riding</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>August 22, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Keep a long-haul flight from ruining mood
//                                                             health...</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news37.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Cycling</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>December 30, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Keep a long-haul flight from ruining mood
//                                                             health...</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row cricket">
//                                     <div className="col-xl-4 col-lg-7 col-md-6 col-sm-12">
//                                         <div className="img-overlay-70 img-scale-animate mb-30">
//                                             <img src="/assets/img/news/news51.jpg" alt="news" className="img-fluid width-100" />
//                                             <div className="topic-box-top-lg">
//                                                 <div className="topic-box-sm color-cod-gray mb-20">Cricket</div>
//                                             </div>
//                                             <div className="mask-content-lg">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>by</span>
//                                                             <Link to="/news-info">Adams</Link>
//                                                         </li>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>May 30, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h2 className="title-medium-light size-lg">
//                                                     <Link to="/news-info">10 Best Water Parks In Theya World you Have
//                                                         to...</Link>
//                                                 </h2>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-xl-8 col-lg-5 col-md-6 col-sm-12">
//                                         <div className="row keep-items-4-md">
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news32.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Ragbe</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>January 17, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Brooke Shields Casts a New Dress Model</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news33.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Boxing</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>February 10, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Brooke Shields Casts a New Dress Model</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news34.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Diving</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>March 06, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Music Evolution, the Most Advanced Audio
//                                                             Mixer</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news35.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Cycling</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>May 17, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Hexagon is the new circle but we need to
//                                                             know in 2017</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news36.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Riding</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>August 22, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Keep a long-haul flight from ruining mood
//                                                             health...</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news37.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Cycling</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>December 30, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Keep a long-haul flight from ruining mood
//                                                             health...</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row football">
//                                     <div className="col-xl-4 col-lg-7 col-md-6 col-sm-12">
//                                         <div className="img-overlay-70 img-scale-animate mb-30">
//                                             <img src="/assets/img/news/news50.jpg" alt="news" className="img-fluid width-100" />
//                                             <div className="topic-box-top-lg">
//                                                 <div className="topic-box-sm color-cod-gray mb-20">Football</div>
//                                             </div>
//                                             <div className="mask-content-lg">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>by</span>
//                                                             <Link to="/news-info">Adams</Link>
//                                                         </li>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>May 30, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h2 className="title-medium-light size-lg">
//                                                     <Link to="/news-info">10 Best Water Parks In Theya World you Have
//                                                         to...</Link>
//                                                 </h2>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-xl-8 col-lg-5 col-md-6 col-sm-12">
//                                         <div className="row keep-items-4-md">
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news32.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Ragbe</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>January 17, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Brooke Shields Casts a New Dress Model</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news33.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Boxing</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>February 10, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Brooke Shields Casts a New Dress Model</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news34.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Diving</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>March 06, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Music Evolution, the Most Advanced Audio
//                                                             Mixer</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news35.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Cycling</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>May 17, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Hexagon is the new circle but we need to
//                                                             know in 2017</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news36.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Riding</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>August 22, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Keep a long-haul flight from ruining mood
//                                                             health...</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news37.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Cycling</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>December 30, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Keep a long-haul flight from ruining mood
//                                                             health...</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row cycling">
//                                     <div className="col-xl-4 col-lg-7 col-md-6 col-sm-12">
//                                         <div className="img-overlay-70 img-scale-animate mb-30">
//                                             <img src="/assets/img/news/news52.jpg" alt="news" className="img-fluid width-100" />
//                                             <div className="topic-box-top-lg">
//                                                 <div className="topic-box-sm color-cod-gray mb-20">Cycling</div>
//                                             </div>
//                                             <div className="mask-content-lg">
//                                                 <div className="post-date-light">
//                                                     <ul>
//                                                         <li>
//                                                             <span>by</span>
//                                                             <Link to="/news-info">Adams</Link>
//                                                         </li>
//                                                         <li>
//                                                             <span>
//                                                                 <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                             </span>May 30, 2017
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                                 <h2 className="title-medium-light size-lg">
//                                                     <Link to="/news-info">10 Best Water Parks In Theya World you Have
//                                                         to...</Link>
//                                                 </h2>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-xl-8 col-lg-5 col-md-6 col-sm-12">
//                                         <div className="row keep-items-4-md">
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news32.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Ragbe</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>January 17, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Brooke Shields Casts a New Dress Model</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news33.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Boxing</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>February 10, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Brooke Shields Casts a New Dress Model</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news34.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Diving</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>March 06, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Music Evolution, the Most Advanced Audio
//                                                             Mixer</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news35.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Cycling</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>May 17, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Hexagon is the new circle but we need to
//                                                             know in 2017</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news36.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Riding</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>August 22, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Keep a long-haul flight from ruining mood
//                                                             health...</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news-info">
//                                                         <img src="/assets/img/news/news37.jpg" alt="news" className="img-fluid width-100 mb-15" />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">Cycling</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                 </span>December 30, 2017
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news-info">Keep a long-haul flight from ruining mood
//                                                             health...</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section> */}

//                 {/* <section className="bg-accent section-space-less30">
//                     <div className="container">
//                         <div className="row">
//                             <div className="col-lg-8 col-md-12">
//                                 <div className="ne-isotope">
//                                     <div className="topic-border color-scampi mb-30">
//                                         <div className="topic-box-lg color-scampi">More News</div>
//                                         <div className="isotope-classes-tab isotop-btn">
//                                             <Link to="#" data-filter=".politics" className="current">Politics</Link>
//                                             <Link to="#" data-filter=".fashion">Fashion</Link>
//                                             <Link to="#" data-filter=".health">Health &amp; Fitness</Link>
//                                             <Link to="#" data-filter=".travel">Travel</Link>
//                                             <Link to="#" data-filter=".gadget">Gadget</Link>
//                                         </div>
//                                         <div className="more-info-link">
//                                             <Link to="post-style-1.html">More
//                                                 <i className="fa fa-angle-right" aria-hidden="true" />
//                                             </Link>
//                                         </div>
//                                     </div>
//                                     <div className="featuredContainer">
//                                         <div className="row politics">
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news38.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-cinnabar mb-20">Politics</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">Erik Jones has day he won’t soon forget
//                                                                 as Denny backup at Bristol</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news39.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-web-orange mb-20">Food</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news40.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-azure-radiance mb-20">Sports</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">A taste of what we like this week at
//                                                                 CookA like this current week</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news41.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-apple mb-20">Life Style</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row fashion">
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news39.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-web-orange mb-20">Food</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news40.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-azure-radiance mb-20">Sports</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">A taste of what we like this week at
//                                                                 CookA like this current week</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news38.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-cinnabar mb-20">Politics</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">Erik Jones has day he won’t soon forget
//                                                                 as Denny backup at Bristol</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news41.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-apple mb-20">Life Style</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row health">
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news40.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-azure-radiance mb-20">Sports</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">A taste of what we like this week at
//                                                                 CookA like this current week</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news41.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-apple mb-20">Life Style</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news38.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-cinnabar mb-20">Politics</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">Erik Jones has day he won’t soon forget
//                                                                 as Denny backup at Bristol</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news39.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-web-orange mb-20">Food</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row travel">
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news40.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-azure-radiance mb-20">Sports</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">A taste of what we like this week at
//                                                                 CookA like this current week</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news38.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-cinnabar mb-20">Politics</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">Erik Jones has day he won’t soon forget
//                                                                 as Denny backup at Bristol</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news39.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-web-orange mb-20">Food</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news41.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-apple mb-20">Life Style</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row gadget">
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news41.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-apple mb-20">Life Style</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news38.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-cinnabar mb-20">Politics</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">Erik Jones has day he won’t soon forget
//                                                                 as Denny backup at Bristol</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news39.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-web-orange mb-20">Food</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">TG G6 will have 13-mgpx cameras on the
//                                                                 back Separated theytics.</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
//                                                 <div className="media media-none--lg mb-30">
//                                                     <div className="position-relative width-40">
//                                                         <Link to="/news-info" className="img-opacity-hover">
//                                                             <img src="/assets/img/news/news40.jpg" alt="news" className="img-fluid" />
//                                                         </Link>
//                                                         <div className="topic-box-top-xs">
//                                                             <div className="topic-box-sm color-azure-radiance mb-20">Sports</div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="media-body p-mb-none-child media-margin30">
//                                                         <div className="post-date-dark">
//                                                             <ul>
//                                                                 <li>
//                                                                     <span>by</span>
//                                                                     <Link to="/news-info">Makr Willy</Link>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span>
//                                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                                     </span>May 30, 2017
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <h3 className="title-semibold-dark size-lg mb-15">
//                                                             <Link to="/news-info">A taste of what we like this week at
//                                                                 CookA like this current week</Link>
//                                                         </h3>
//                                                         <p>Separated they live in Bookmarksgrove right at the coast of the
//                                                             Semantics,
//                                                             a large ocean. A small river named Duden flows by their place and
//                                                             ...
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="ne-sidebar sidebar-break-md col-lg-4 col-md-12">
//                                 <div className="sidebar-box">
//                                     <div className="ne-banner-layout1 text-center">
//                                         <Link to="#">
//                                             <img src="/assets/img/banner/banner6.jpg" alt="ad" className="img-fluid" />
//                                         </Link>
//                                     </div>
//                                 </div>
//                                 <div className="sidebar-box">
//                                     <div className="topic-border color-cod-gray mb-30">
//                                         <div className="topic-box-lg color-cod-gray">Newsletter</div>
//                                     </div>
//                                     <div className="newsletter-area bg-primary">
//                                         <h2 className="title-medium-light size-xl">Subscribe to our mailing list to get the new
//                                             updates!</h2>
//                                         <img src="/assets/img/banner/newsletter.png" alt="newsletter" className="img-fluid mb-40" />
//                                         <p>Subscribe our newsletter to stay updated every moment</p>
//                                         <div className="input-group stylish-input-group">
//                                             <input type="text" placeholder="Enter your mail" className="form-control" />
//                                             <span className="input-group-addon">
//                                                 <button type="submit">
//                                                     <i className="fa fa-angle-right" aria-hidden="true" />
//                                                 </button>
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>

//                 <section className="bg-body section-space-less2">
//                     <div className="container">
//                         <div className="row tab-space1">
//                             <div className="col-lg-4 col-md-6 col-sm-6 col-12">
//                                 <div className="category-box-layout1 overlay-dark-level-2 img-scale-animate text-center mb-2">
//                                     <img src="/assets/img/category/ctg1.jpg" alt="news" className="img-fluid width-100" />
//                                     <div className="content p-30-r">
//                                         <div className="ctg-title-xs">Music</div>
//                                         <h3 className="title-regular-light size-lg">
//                                             <Link to="post-style-1.html">Microsoft and Autodesk help industrial designers…</Link>
//                                         </h3>
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>March 22, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-4 col-md-6 col-sm-6 col-12">
//                                 <div className="category-box-layout1 overlay-dark-level-2 img-scale-animate text-center mb-2">
//                                     <img src="/assets/img/category/ctg2.jpg" alt="news" className="img-fluid width-100" />
//                                     <div className="content p-30-r">
//                                         <div className="ctg-title-xs">Education</div>
//                                         <h3 className="title-regular-light size-lg">
//                                             <Link to="post-style-2.html">Apple’s new AirPods are feature rich but fugly</Link>
//                                         </h3>
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>April 20, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-4 col-md-6 col-sm-6 col-12">
//                                 <div className="category-box-layout1 overlay-dark-level-2 img-scale-animate text-center mb-2">
//                                     <img src="/assets/img/category/ctg3.jpg" alt="news" className="img-fluid width-100" />
//                                     <div className="content p-30-r">
//                                         <div className="ctg-title-xs">Travel</div>
//                                         <h3 className="title-regular-light size-lg">
//                                             <Link to="post-style-3.html">All People Gather Strategic Supplies of Vegetables</Link>
//                                         </h3>
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>May 03, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-4 col-md-6 col-sm-6 col-12">
//                                 <div className="category-box-layout1 overlay-dark-level-2 img-scale-animate text-center mb-2">
//                                     <img src="/assets/img/category/ctg4.jpg" alt="news" className="img-fluid width-100" />
//                                     <div className="content p-30-r">
//                                         <div className="ctg-title-xs">Sprts</div>
//                                         <h3 className="title-regular-light size-lg">
//                                             <Link to="post-style-4.html">The Whole World is Expecting the Best iPhone Ever
//                                                 Created</Link>
//                                         </h3>
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>July 09, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-4 col-md-6 col-sm-6 col-12">
//                                 <div className="category-box-layout1 overlay-dark-level-2 img-scale-animate text-center mb-2">
//                                     <img src="/assets/img/category/ctg5.jpg" alt="news" className="img-fluid width-100" />
//                                     <div className="content p-30-r">
//                                         <div className="ctg-title-xs">Food</div>
//                                         <h3 className="title-regular-light size-lg">
//                                             <Link to="post-style-1.html">Gym Fitness area coverded Governed this in 2017</Link>
//                                         </h3>
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>October 28, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-4 col-md-6 col-sm-6 col-12">
//                                 <div className="category-box-layout1 overlay-dark-level-2 img-scale-animate text-center mb-2">
//                                     <img src="/assets/img/category/ctg6.jpg" alt="news" className="img-fluid width-100" />
//                                     <div className="content p-30-r">
//                                         <div className="ctg-title-xs">Education</div>
//                                         <h3 className="title-regular-light size-lg">
//                                             <Link to="post-style-2.html">What To Avoid When Planning Your Honeymoon</Link>
//                                         </h3>
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li>
//                                                     <span>
//                                                         <i className="fa fa-calendar" style={{color:"black"}} aria-hidden="true" />
//                                                     </span>December 19, 2017
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section> */}







//             </div>

//         </>
//     )
// }

// export default HomeBanner





import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const staticHomeBanner = [
  {
    _id: "692c4e04c8e1c32e293bb743",
    sectionTitle: "विज्ञापन सूचना",
    sectionSlug: "1. यदि आप अपनी कोई खबर, सार्वजनिक सूचना, गुमशुदा, नाम परिवर्तन सूचना, बिजनेस आइडिया, रिसर्च रिपोर्ट, विज्ञापन, जन्मदिवस, पुण्यतिथि, सालगिरह की बधाईयाॅ प्रकाशित कराना चाहते है तो आप हमसे 7987667358 पर संपर्क या व्हाट्सअप कर सकते है। अथवा डिटेल्स के साथ डाक्यूमेन्ट्स अटेच कर starnewsnetworks1988@gmail.com पर ईमेल करें। धन्यवाद //                                                 2. अगर आप हमसे जुड़ना चाहते है या कोई विज्ञापन देना चाहते है या हमें कोई सुझाव देना चाहते है तो हमसे मो0न0 7987667358 पर संपर्क या व्हाट्सअप करें|",
    mainNews: {
      title: "सीएम मोहन बोले- एमपी में चलेंगी 900 ई-बसें",
      imageUrl: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1764511235/homeBanner/mainNews/f4avogdc2rhom45imaye.jpg",
      publicId: null,
      category: "पन्ना की ताज़ा खबरें",
      publishDate: "2025-11-04T00:00:00.000Z",
      description: "प्रदेश के ग्वालियर, जबलपुर, उज्जैन, भोपाल, इंदौर नगर निगम क्षेत्रों में ई- बसों के लिए चार्जिंग स्टेशन बनाए जाने के…"
    },
    sideNews: [
      {
        _id: "692dbd7297ba0e7162a2e6af",
        title: "j111",
        imageUrl: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1764600524/homeBanner/sideNews/e8pmqj3uffgauf9yyvfy.png",
        publicId: "homeBanner/sideNews/e8pmqj3uffgauf9yyvfy",
        category: "bb111",
        publishDate: "2025-11-13T00:00:00.000Z",
        description: "b111"
      },
      {
        _id: "692dbd7297ba0e7162a2e6b0",
        title: "ss111",
        imageUrl: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1764600283/homeBanner/sideNews/rbowdjvrzbxm8oivjdlf.png",
        publicId: "homeBanner/sideNews/rbowdjvrzbxm8oivjdlf",
        category: "ss111",
        publishDate: "2025-12-24T00:00:00.000Z",
        description: "sss1111"
      }
    ],
    tickerNews: [
      {
        _id: "692dbd7297ba0e7162a2e6b1",
        content: "h"
      },
      {
        _id: "692dbd7297ba0e7162a2e6b2",
        content: "sss1111"
      }
    ],
    createdAt: "2025-11-30T14:00:36.896Z",
    updatedAt: "2025-12-01T16:08:18.939Z",
    __v: 0
  }
];

const HomeBanner = () => {
  const [bannerData, setBannerData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/v1/users/get-home-banner`
        );
        console.log("HomeBanner API response:", res.data);
        const apiData = res.data?.data;

        if (Array.isArray(apiData) && apiData.length > 0) {
          setBannerData(apiData);
        } else {
          console.log("Using static fallback data");
          setBannerData(staticHomeBanner);
        }
      } catch (err) {
        console.error("HomeBanner API error:", err);
        setBannerData(staticHomeBanner);
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  // Format date helper
  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString("en-IN", {
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    } catch {
      return "Invalid Date";
    }
  };

  // Get current date and time
  const getCurrentDate = () => {
    return new Date().toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  };

  const getCurrentTime = () => {
    return new Date().toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  };

  if (loading) {
    return (
      <div className="wrapper" id="wrapper">
        <div className="container text-center py-5">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="wrapper" id="wrapper">
      {bannerData.map((banner, idx) => (
        <React.Fragment key={banner._id || idx}>
          {/* 🔹 Ticker Section */}
          <section className="bg-accent border-bottom add-top-margin">
            <div className="row no-gutters d-flex align-items-center tejbhan" >
              <div className="col-lg-2 col-md-3 col-sm-4 col-6" >
                <div className="topic-box topic-box-margin">
                  {banner.sectionTitle || "शीर्ष समाचार"}
                </div>
              </div>
              <div className="col-lg-10 col-md-9 col-sm-8 col-6" >
                <div className="feeding-text-dark">
                  <marquee width="100%" direction="left" >
                    {banner.tickerNews && banner.tickerNews.length > 0 ? (
                      banner.tickerNews.map((t, i) => (
                        <span key={t._id || i} style={{ color: "white", fontWeight: "bold", fontSize: "18px" }}>
                          {i + 1}. {t.content} &nbsp;&nbsp;&nbsp;
                        </span>
                      ))
                    ) : (
                      <span>No ticker news available</span>
                    )}
                  </marquee>
                </div>
              </div>
            </div>
          </section>

          {/* 🔹 Info Section */}
          <section className="bg-body">
            <div className="container">
              <ul className="news-info-list text-center--md">
                <li>India</li>
                <li>
                  <i className="fa fa-calendar" /> {getCurrentDate()}
                </li>
                <li>
                  <i className="fa fa-clock-o" /> Last Update {getCurrentTime()}
                </li>
                <li>
                  <i className="fa fa-cloud" /> 29℃ Friday
                </li>
              </ul>
            </div>
          </section>

          {/* 🔹 Main Banner */}
          <section className="bg-accent section-space-less2">
            <div className="container">
              <div className="row tab-space1">
                {/* MAIN NEWS */}
                {banner.mainNews && (
                  <div className="col-lg-6 col-md-12 mb-3">
                    <div
                      className="img-overlay-70 img-scale-animate"
                      style={{ height: "400px", overflow: "hidden", position: "relative" }}
                    >
                      <img
                        src={banner.mainNews.imageUrl}
                        alt={banner.mainNews.title}
                        className="img-fluid width-100"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover"
                        }}
                      />
                      <div className="mask-content-lg">
                        <div className="topic-box-sm mb-20">
                          {banner.mainNews.category}
                        </div>
                        <div className="post-date-light">
                          <ul>
                            <li>
                              <span>by</span> <Link to="#">Admin</Link>
                            </li>
                            <li>
                              <i className="fa fa-calendar" />{" "}
                              {formatDate(banner.mainNews.publishDate)}
                            </li>
                            <li>
                              <i className="fa fa-share-alt" style={{ fontSize: "25px" }} />
                            </li>
                            <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
                            <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
                          </ul>
                        </div>
                        <h1 className="title-medium-light">
                          <Link to="#">{banner.mainNews.title}</Link>
                        </h1>
                        <p style={{ color: "white" }}>
                          {banner.mainNews.description}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* SIDE NEWS */}
                <div className="col-lg-6 col-md-12">
                  <div className="row">
                    {banner.sideNews && banner.sideNews.length > 0 ? (
                      banner.sideNews.map((side, i) => (
                        <div className="col-12 mb-3" key={side._id || i}>
                          <div
                            className="img-overlay-70 img-scale-animate"
                            style={{
                              height: "190px",
                              overflow: "hidden",
                              position: "relative"
                            }}
                          >
                            <img
                              src={side.imageUrl}
                              alt={side.title}
                              className="img-fluid width-100"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                              }}
                            />
                            <div className="mask-content-sm">
                              <div className="topic-box-sm mb-10">
                                {side.category}

                              </div>
                              <h2 className="title-medium-light">
                                <Link to="#">{side.title}</Link>
                              </h2>

                              <p style={{ color: "white" }}>{side.description}</p>

                              <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "white" }} />
                              <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
                              <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "white", margin: "10px" }} />

                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12">
                        <p className="text-center">No side news available</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </React.Fragment>
      ))}
    </div>
  );
};

export default HomeBanner;
